import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/useAuthStore';
import { getDefaultRouteForRole, UserRole } from './roles';

interface GuestRouteProps {
  children: React.ReactNode;
}

/**
 * GuestRoute Component
 * Redirects authenticated users away from public pages (like login, landing)
 * to their role-specific dashboard
 *
 * Features:
 * - Checks if user is already authenticated
 * - Redirects authenticated users to their dashboard
 * - Allows unauthenticated users to access public pages
 *
 * Usage:
 * <GuestRoute>
 *   <LoginPage />
 * </GuestRoute>
 */
const GuestRoute: React.FC<GuestRouteProps> = ({ children }) => {
  const { isAuthenticated, user } = useAuthStore();

  // If user is authenticated, redirect to their dashboard
  if (isAuthenticated && user) {
    console.log('🔒 GuestRoute: User is authenticated, redirecting to dashboard');
    const defaultRoute = getDefaultRouteForRole(user.role as UserRole);
    return <Navigate to={defaultRoute} replace />;
  }

  // User is not authenticated, show public page
  console.log('✅ GuestRoute: User is not authenticated, showing public page');
  return <>{children}</>;
};

export default GuestRoute;
